
import Vue from 'vue';
import Component from 'vue-class-component';
import { State, Action } from 'vuex-class';

import { User } from '@/models/user.types';

@Component
export default class ForgotPassword extends Vue {
  /* VUEX */

  // ACTIONS
  @Action('authLayout') private authLayout: any;
  @Action('actionForgotPassword', { namespace: 'user' })
  private actionForgotPassword: any;

  // STATE
  @State('user') private user: User;

  /* INITIALIZATION */

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {
    this.authLayout();
  }

  private mounted() {
    this.$emit(
      'updateTitle',
      'Lupa <span class="bold d-block">Kata Sandi</span>',
      'Jangan khawatir, kami membantu anda',
    );
  }

  /* LISTENER */

  private listener() {
    this.$router.push({ name: 'login' });
  }
}
